var map = {
	".": 71,
	"./": 71,
	"./Icons/Amazon": 612,
	"./Icons/Amazon.js": 612,
	"./Icons/Amex": 613,
	"./Icons/Amex.js": 613,
	"./Icons/Applepay": 614,
	"./Icons/Applepay.js": 614,
	"./Icons/Aura": 615,
	"./Icons/Aura.js": 615,
	"./Icons/Bb": 616,
	"./Icons/Bb.js": 616,
	"./Icons/Bitcoin": 617,
	"./Icons/Bitcoin.js": 617,
	"./Icons/Boleto": 618,
	"./Icons/Boleto.js": 618,
	"./Icons/Bradesco": 619,
	"./Icons/Bradesco.js": 619,
	"./Icons/Caixa": 620,
	"./Icons/Caixa.js": 620,
	"./Icons/Cielo": 621,
	"./Icons/Cielo.js": 621,
	"./Icons/Cirrus": 622,
	"./Icons/Cirrus.js": 622,
	"./Icons/Diners": 623,
	"./Icons/Diners.js": 623,
	"./Icons/DirectDebit": 624,
	"./Icons/DirectDebit.js": 624,
	"./Icons/Discover": 625,
	"./Icons/Discover.js": 625,
	"./Icons/Ebay": 626,
	"./Icons/Ebay.js": 626,
	"./Icons/Elavon": 627,
	"./Icons/Elavon.js": 627,
	"./Icons/Elo": 628,
	"./Icons/Elo.js": 628,
	"./Icons/Eway": 629,
	"./Icons/Eway.js": 629,
	"./Icons/Generic": 630,
	"./Icons/Generic.js": 630,
	"./Icons/Global": 631,
	"./Icons/Global.js": 631,
	"./Icons/Googlepay": 632,
	"./Icons/Googlepay.js": 632,
	"./Icons/Hsbc": 633,
	"./Icons/Hsbc.js": 633,
	"./Icons/Itau": 634,
	"./Icons/Itau.js": 634,
	"./Icons/Jcb": 635,
	"./Icons/Jcb.js": 635,
	"./Icons/Maestro": 636,
	"./Icons/Maestro.js": 636,
	"./Icons/Mastercard": 637,
	"./Icons/Mastercard.js": 637,
	"./Icons/Pagseguro": 638,
	"./Icons/Pagseguro.js": 638,
	"./Icons/Paypal": 639,
	"./Icons/Paypal.js": 639,
	"./Icons/Rede": 640,
	"./Icons/Rede.js": 640,
	"./Icons/Sage": 641,
	"./Icons/Sage.js": 641,
	"./Icons/Santander": 642,
	"./Icons/Santander.js": 642,
	"./Icons/Shopify": 643,
	"./Icons/Shopify.js": 643,
	"./Icons/Skrill": 644,
	"./Icons/Skrill.js": 644,
	"./Icons/SkrillMoneybookers": 645,
	"./Icons/SkrillMoneybookers.js": 645,
	"./Icons/Solo": 646,
	"./Icons/Solo.js": 646,
	"./Icons/Stone": 647,
	"./Icons/Stone.js": 647,
	"./Icons/Visa": 648,
	"./Icons/Visa.js": 648,
	"./Icons/VisaElectron": 649,
	"./Icons/VisaElectron.js": 649,
	"./Icons/Wallet": 650,
	"./Icons/Wallet.js": 650,
	"./Icons/Western": 651,
	"./Icons/Western.js": 651,
	"./Icons/Worldpay": 652,
	"./Icons/Worldpay.js": 652,
	"./Icons/transparent/AmazonTransparent": 653,
	"./Icons/transparent/AmazonTransparent.js": 653,
	"./Icons/transparent/BbTransparent": 654,
	"./Icons/transparent/BbTransparent.js": 654,
	"./Icons/transparent/BoletoTransparent": 655,
	"./Icons/transparent/BoletoTransparent.js": 655,
	"./Icons/transparent/BradescoTransparent": 656,
	"./Icons/transparent/BradescoTransparent.js": 656,
	"./Icons/transparent/CaixaTransparent": 657,
	"./Icons/transparent/CaixaTransparent.js": 657,
	"./Icons/transparent/CieloTransparent": 658,
	"./Icons/transparent/CieloTransparent.js": 658,
	"./Icons/transparent/ElavonTransparent": 659,
	"./Icons/transparent/ElavonTransparent.js": 659,
	"./Icons/transparent/GenericTransparent": 660,
	"./Icons/transparent/GenericTransparent.js": 660,
	"./Icons/transparent/GlobalTransparent": 661,
	"./Icons/transparent/GlobalTransparent.js": 661,
	"./Icons/transparent/HsbcTransparent": 662,
	"./Icons/transparent/HsbcTransparent.js": 662,
	"./Icons/transparent/ItauTransparent": 663,
	"./Icons/transparent/ItauTransparent.js": 663,
	"./Icons/transparent/PagseguroTransparent": 664,
	"./Icons/transparent/PagseguroTransparent.js": 664,
	"./Icons/transparent/PaypalTransparent": 665,
	"./Icons/transparent/PaypalTransparent.js": 665,
	"./Icons/transparent/RedeTransparent": 666,
	"./Icons/transparent/RedeTransparent.js": 666,
	"./Icons/transparent/SantanderTransparent": 667,
	"./Icons/transparent/SantanderTransparent.js": 667,
	"./Icons/transparent/StoneTransparent": 668,
	"./Icons/transparent/StoneTransparent.js": 668,
	"./Icons/transparent/WalletTransparent": 669,
	"./Icons/transparent/WalletTransparent.js": 669,
	"./Icons/transparent/WorldpayTransparent": 670,
	"./Icons/transparent/WorldpayTransparent.js": 670,
	"./index": 71,
	"./index.js": 71,
	"./remoteImages": 492,
	"./remoteImages.js": 492,
	"./test": 671,
	"./test.js": 671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1081;